/**
 * Translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancelar',
    CONFIRM: 'Confirmar',
    NEW_INVOICE: 'Nova fatura'
  },
  ERROR: {
    ACCUMULATE_SUBMITTED: 'Erro ao submeter acumulação',
    CANCEL_ACCUMULATION: 'Erro ao cancelar acumulação',
    CANCEL_INVOICE: 'Erro ao cancelar fatura',
    COUPON_CANCELED: 'Erro ao cancelar cupão',
    COUPON_GENERATED: 'Erro a gerar cupão',
    ERROR: 'Erro',
    INVOICE_SUBMITTED: 'Erro a submeter fatura'
  },
  HEADER: {
    ACCU_REMUNERATION: 'Acu. remuneração',
    ATTACHMENT: 'Anexo',
    CHALLENGE: 'Desafio',
    COUPON: 'Cupão',
    COUPON_CODE: 'Código cupão',
    DECISION: 'Decisão',
    MONTH: 'Mês',
    OBSERVATIONS: 'Observações',
    REMUNERATION: 'Remuneração',
    STATE: 'Estado',
    SUBMISSION_DATE: 'Data Submissão'
  },
  LABEL: {
    ACCUMULATE: 'Acumular',
    ACCUMULATED: 'Acumulado',
    ACTIVES: 'Ativas',
    ALL: 'Todos',
    BEGIN_DATE: 'Data de início',
    CANCEL: 'Cancelar',
    CANCEL_ACCUMULATION: 'Cancelar acumulação',
    CANCEL_COUPON: 'Cancelar cupão',
    CANCEL_INVOICE: 'Cancelar Fatura',
    CLOSE: 'Fechar',
    CODE: 'Código',
    CONFIRM: 'Confirmar',
    CONFIRM_ACCUMULATE: 'Acumular',
    CONFIRM_COUPON_CREATION: 'Gerar cupão',
    CONFIRM_SUBMIT_INVOICE: 'Enviar',
    COPY_COUPON_CODE: 'Copiar código',
    COUPON: 'Cupão',
    COUPON_CODE: 'Código do cupão',
    CURRENT_PERIOD: 'P. corr.',
    DATE: 'Data',
    DESCRIPTION: 'Descrição',
    END_DATE: 'Data de fim',
    FILTER: 'Filtrar',
    GENERATE_COUPON: 'Gerar cupão',
    GO_TO_DETAILS: 'Ver produtos',
    INVOICE: 'Fatura',
    MODEL: 'Modelo',
    MONEY: 'Dinheiro',
    MONTH: 'Mês',
    NEW_INVOICE: 'Nova fatura',
    PAYMENT_METHOD: 'Modo de pagamento',
    PENDING_COUNTERPARTS: 'Contrapartidas Pendentes',
    PENDING_COUNTERPARTS_MODAL_TITLE: 'Existem contrapartidas por validar',
    PENDING_VALUE: 'Valor por faturar',
    PREVIOUS_PERIOD: 'P. ant.',
    REMUNERATION: 'Remuneração',
    SELECTED_PRODUCTS: 'Produtos selecionados',
    STATE: 'Estado',
    SUBMIT_INVOICE_ATTACHMENT: 'Anexos (PDF)',
    SUBMIT_INVOICE_COMMENT: 'Comentário',
    SUBMIT_MANUAL_REMUNERATION_INVOICE_VALUE: 'Valor',
    WITHOUT_PRODUCTS: 'Sem Produtos selecionados',
    YEAR: 'Ano'
  },
  SENTENCE: {
    CANCEL_ACCUMULATION: 'Tem a certeza que deseja cancelar a acumulação?',
    CANCEL_COUPON: 'Tem a certeza que pretende cancelar o cupão {value}?',
    CANCEL_INVOICE: 'Tem a certeza que deseja cancelar a submissão da fatura?',
    CANT_GENERATE_COUPON: 'Não pode gerar cupão.',
    CANT_SUBMIT_REMUNERATION: 'Não pode submeter fatura.',
    CONFIRM_SUBMIT_COUPON:
      'Estás a gerar um cupão no valor de {couponValue}. Pretendes concluir esta operação?',
    EMPTY_TITLE: 'Sem resultados'
  },
  SUCCESS: {
    ACCUMULATE_SUBMITTED: 'Remuneração acumulada',
    CANCEL_ACCUMULATION: 'Acumulação cancelada',
    CANCEL_INVOICE: 'Fatura cancelada',
    COUPON_CANCELED: 'Cupão cancelado',
    COUPON_COPIED: 'Código do cupão copiado',
    COUPON_GENERATED: 'Cupão gerado com o código %{value}',
    INVOICE_SUBMITTED: 'Fatura submetida',
    SUCCESS: 'Sucesso'
  },
  TOOLTIP: {
    ACCU_REMUNERATION: 'Acu. remuneração',
    ATTACHMENT: 'Anexo',
    CHALLENGE: 'Desafio',
    COUPON: 'Cupão',
    COUPON_CODE: 'Código cupão',
    DECISION: 'Decisão',
    MONTH: 'Mês',
    OBSERVATIONS: 'Observações',
    REMUNERATION: 'Remuneração',
    STATE: 'Estado',
    SUBMISSION_DATE: 'Data Submissão',
    SWIPE: 'Deslize para a esquerda para ver mais colunas.',
    VIEW_CHALLENGE_DETAILS: 'Ver detalhes do desafio'
  }
};
